import { z } from 'zod'

export const ADMINBILLINGPROXYPOST_CONTRACT_VERSION = '1.0.0' as const
export const adminBillingProxyPostResponseSchema = z.unknown()
export type AdminBillingProxyPostResponse = z.infer<typeof adminBillingProxyPostResponseSchema>
